export default {
  meta: {
    title: 'PDF-无意义'
  }
};
